export const selectAuthToken = (state) => state.auth.userData?.token;

export const selectCompanyUUID = (state) => state.auth.userData?.user?.company?.uuid;

export const selectCompanyAccessCode = (state) => state?.auth?.userData?.user?.company?.uuid;

export const selectLoggedInUser = (state) => state?.auth?.userData?.user;
